import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { Typography } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import ReactSelectMaterial from '../../components/ReactSelectMaterial/ReactSelectMaterial';
import api from '../../constants/api';
import DateInput from '../../components/FormFieldComponents/DateInput/DateInput';
import { formatDateToString, parseDate } from '../../constants/DateUtil';
import { apiCatchBlockFunction } from '../../constants/CommonUtil';
import ActionButton from '../../components/ActionButton/ActionButton';
import { errorMessage } from '../../redux/modules/message/message-actions';
import { hideSpinner, showSpinner } from '../../redux/modules/spinner/spinner';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';
import { getStringFromObject } from '../../constants/lodashUtils';


class RegenerateAttendanceForEmployee extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            employee: null,
            startDate: null,
            endDate: null,
            period: null,
            processWithoutShiftTiming: false,

        };
    }

    onProcessChange = (event) => {
        this.setState({
            processWithoutShiftTiming: event.target.checked,
        });
    };

    onChangeValue = fieldName => (changedValue) => {
        this.setState({
            [fieldName]: changedValue,
        });
    };

    onChangePeriod = (period) => {
        let startDate = '';
        let endDate = '';
        if (isObjectValidAndNotEmpty(period)) {
            startDate = parseDate(period.startDate, 'yyyy-MM-dd').getTime();
            endDate = parseDate(period.endDate, 'yyyy-MM-dd').getTime();
        }
        this.setState({
            period,
            startDate,
            endDate,
        });
    };
    onRegenerateAttendance = () => {
        const {
            employee,
            startDate,
            endDate,
            processWithoutShiftTiming,
        } = this.state;
        const {
            dispatch,
        } = this.props;

        if (!isObjectValidAndNotEmpty(employee)) {
            dispatch(errorMessage('Please enter an employee'));
            return;
        }

        if (!endDate && !startDate) {
            dispatch(errorMessage('Date range is mandatory'));
            return;
        }
        const employeeUuids = employee.map(({ key }) => key);
        const stDate = formatDateToString(new Date(startDate), 'dd/MM/yyyy');
        const enDate = formatDateToString(new Date(endDate), 'dd/MM/yyyy');

        dispatch(showSpinner());
        const p = Promise.race([
            axios.get(
                `${api.ATTENDANCE.REGENERATE_ATTENDANCE_FOR_EMPLOYEE
                }${encodeURIComponent(employeeUuids)}&fromDateString=${stDate}&toDateString=${enDate}&processWithoutShiftTiming=${processWithoutShiftTiming}`,
            ),
            new Promise((resolve) => {
                setTimeout(() => resolve('resolved in 5 sec'), 3000);
            }),
        ]);
        p.then(() => {
            console.log('asd-9asudas0aas');
            dispatch(hideSpinner());
            this.props.handleClose();
        });
        p.catch(e => apiCatchBlockFunction(e, dispatch));
    };
    render() {
        const {
            employee,
            startDate,
            endDate,
            period,
            processWithoutShiftTiming,
        } = this.state;

        const {
            dispatch,
            allowAttendanceProcessWithoutShiftTiming,
        } = this.props;

        console.log(dispatch, endDate);
        return (
            <React.Fragment>
                <Grid container spacing={16}>
                    <Grid item sm={6} md={6} lg={6}>
                        <ReactSelectMaterial
                            fullWidth
                            dataSourceConfig={{
                                text: 'value',
                                value: 'key',
                            }}
                            multiple
                            autoFocus
                            label="Employee"
                            autocomplete
                            dataSourceApi={`${api.EMPLOYEE.GET_SUGGESTION}?name=`}
                            onChange={this.onChangeValue('employee')}
                            value={employee}
                            required
                            placeholder="Search with Employee Name/ID"
                            testId="employee"
                            getOptionLabel={option => `${option.displayLabel}`}
                        />
                    </Grid>
                    <Grid item sm={6} md={6} lg={6}>
                        <ReactSelectMaterial
                            dataSourceApi={`${api.PAYROLL.ALL_PERIODS}?size=4&searchString=`}
                            dataSourceConfig={{
                                value: 'uuid',
                                text: 'displayWithDates',
                            }}
                            onChange={this.onChangePeriod}
                            label="Period"
                            value={period}
                            testId="period"
                        />
                    </Grid>
                    <Grid item sm={3} md={3} lg={3}>
                        <DateInput
                            label="Start Date"
                            value={startDate}
                            onChange={this.onChangeValue('startDate')}
                        />
                    </Grid>
                    <Grid item sm={3} md={3} lg={3}>
                        <DateInput
                            label="End Date"
                            value={endDate}
                            onChange={this.onChangeValue('endDate')}
                        />
                    </Grid>
                    {
                        allowAttendanceProcessWithoutShiftTiming && (
                            <Grid item container sm={5} md={5} lg={5} alignItems="center" justify="flex-end">
                                <Grid item>
                                    <Checkbox
                                        checked={processWithoutShiftTiming}
                                        onChange={this.onProcessChange}
                                    />
                                </Grid>
                                <Grid item>
                                    <Typography>
                                Process without shift timings.
                                    </Typography>
                                </Grid>
                            </Grid>
                        )
                    }
                    <Grid sm={12} className="mt=1">
                        <strong>Warning: Regeneration will result in the loss of manually edited attendance changes.</strong>
                    </Grid>
                    <Grid item sm={12} md={12} lg={12} className="flexChildren justify-content-right">
                        <ActionButton
                            onClick={this.onRegenerateAttendance}
                            testId="regenerate-attendance"
                        >
                            Regenerate Attendance
                        </ActionButton>
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

RegenerateAttendanceForEmployee.propTypes = {
    dispatch: PropTypes.func,
    handleClose: PropTypes.func,
    allowAttendanceProcessWithoutShiftTiming: PropTypes.bool,
};

RegenerateAttendanceForEmployee.defaultProps = {
    dispatch: () => {},
    handleClose: () => { },
    allowAttendanceProcessWithoutShiftTiming: false,
};

const mapStateToProps = state => ({
    allowAttendanceProcessWithoutShiftTiming: getStringFromObject('appConfiguration.allowAttendanceProcessWithoutShiftTiming', state) || false,
});


export default connect(mapStateToProps)(RegenerateAttendanceForEmployee);

